import Swal from "sweetalert2";
import { message } from "antd";
import {
  getCurrentUserPin,
  setPagatPinUnlocked,
} from "./getCurrentUserPin";

/**
 * SweetAlert PIN prompt used for Pagat access (and similar gates).
 * @returns {Promise<boolean>} true if PIN accepted
 */
export async function promptPagatPin({
  users,
  authUser,
  isDarkMode = false,
  unlockSession = true,
} = {}) {
  const expected = getCurrentUserPin(users, authUser);
  if (!expected) {
    message.error("Nuk u gjet kodi personal. Vendoseni te Profili.");
    return false;
  }

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const result = await Swal.fire({
      title: "Vendos kodin personal!",
      input: "password",
      inputAttributes: {
        autocapitalize: "off",
        autocomplete: "off",
      },
      customClass: {
        popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
        container: "pagat-pin-swal",
      },
      showCancelButton: true,
      cancelButtonText: "Anulo",
      confirmButtonText: "Konfirmo",
      cancelButtonColor: "#ea3943",
      confirmButtonColor: "#1da193",
      reverseButtons: true,
      allowOutsideClick: () => !Swal.isLoading(),
      heightAuto: false,
    });

    if (!result.isConfirmed) return false;

    if (String(result.value ?? "") === expected) {
      if (unlockSession) setPagatPinUnlocked(true);
      return true;
    }

    message.error("Kodi i vendosur eshte gabim!");
  }
}
